// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: "https://safetyinductionapi-dev.alec.ae/api",
  apiUrl: 'http://localhost:7071/api',
  recaptchaSiteKey: '6LdN8TMgAAAAAONj8JEfURFBYqv5HaCi9EEsWPjt',
  recaptchaSiteSecret: '6LdN8TMgAAAAAOty4xScp1b8qjrc6mN1ZU4ilKV3',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
